import flyingMacbook from './image/Flying_Macbook.png';
import flyingMacbookPro from './image/Flying_Macbook_Pro.png';
import flyingMacbookBusiness from './image/Flying_Macbook_Business.png';
import flyingPhone1 from './image/Flying_Phone1.png';
import flyingPhone2 from './image/Flying_Phone2.png';
import flyingTablet from './image/Flying_Tablet.png';
import flyingAirplane from './image/Flying_Airplane.png';
import flyingAirplaneRight from './image/Flying_Airplane_Right.png';
import tablet from './image/Tablet.png';

export type Images =
  | 'flyingMacbook'
  | 'flyingMacbookPro'
  | 'flyingMacbookBusiness'
  | 'flyingPhone1'
  | 'flyingPhone2'
  | 'flyingTablet'
  | 'flyingAirplane'
  | 'flyingAirplaneRight'
  | 'tablet';

export const ImageMap: { [key in Images]: { src: string; alt: string } } = {
  flyingMacbook: {
    src: flyingMacbook,
    alt: 'flying-Macbook',
  },
  flyingMacbookPro: {
    src: flyingMacbookPro,
    alt: 'flying-Macbook-Pro',
  },
  flyingPhone1: {
    src: flyingPhone1,
    alt: 'flying-Phone1',
  },
  flyingPhone2: {
    src: flyingPhone2,
    alt: 'flying-Phone2',
  },
  flyingTablet: {
    src: flyingTablet,
    alt: 'flying-Tablet',
  },
  flyingMacbookBusiness: {
    src: flyingMacbookBusiness,
    alt: 'flying-Macbook-Business',
  },
  flyingAirplane: {
    src: flyingAirplane,
    alt: 'flying-Airplane',
  },
  flyingAirplaneRight: {
    src: flyingAirplaneRight,
    alt: 'flying-Airplane-right',
  },
  tablet: {
    src: tablet,
    alt: 'tablet',
  },
};
